import React from 'react';
import { Container, Paper, Box, Grid } from '@mui/material';
import Typography from '../../components/atoms/typography';
import { newPrivacyPolicy } from './steps';


const PrivacyPolicy: React.FC = () => {
  const steps = [
    newPrivacyPolicy,
    // DriverInformation,
    // DistributorInformation,
    // ThirdPartyData,
    // DataSecurity,
    // FinalProvisions,
    // AccessControl,
    // UpdatePrivacy,
  ];
  return (
    <Container component="main" maxWidth="md">
      <Box mt={4} mb={4}>
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '20px',
          }}
        >
          <img
            src="//img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=h:75,cg:true,m/qt=q:95"
            srcSet="//img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=w:303,h:75,cg:true,m/cr=w:303,h:75/qt=q:95, //img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=w:607,h:150,cg:true,m/cr=w:607,h:150/qt=q:95 2x, //img1.wsimg.com/isteam/ip/cbe4f3c4-a694-4126-9fa6-68170e7a839d/Fretapp_Web_OG.png/:/rs=w:910,h:225,cg:true,m/cr=w:910,h:225/qt=q:95 3x"
            alt="Fretapp - Entregando Soluções"
          />
        </Grid>
      </Box>

      <Box mt={4} mb={4}>
        <Paper elevation={3}>
          <Box p={4}>
            {/* <Typography fontSize="5xl" fontWeight="bold" textAlign="justify">
              ANEXO II – POLÍTICA DE PRIVACIDADE
            </Typography> */}
            <br />
            <Typography fontSize="5xl" fontWeight="bold" textAlign="justify">
              POLÍTICA DE PRIVACIDADE
            </Typography>
            <br />
            {/* <Typography fontSize="5xl" fontWeight="bold" textAlign="justify">
              SUMÁRIO:
            </Typography>
            <br />
            <Typography fontSize="4xl" textAlign="justify">
              <Typography>
                1 – COLETA E UTILIZAÇÃO DAS INFORMAÇÕES DOS MOTORISTAS
              </Typography>
              <Typography>
                1.1 – COLETA E UTILIZAÇÃO DAS INFORMAÇÕES DAS DISTRIBUIDORAS
                </Typography>
              <Typography>
                2 – COLETA E UTILIZAÇÃO DAS INFORMAÇÕES DAS DISTRIBUIDORAS
              </Typography>
              <Typography>
                3 – COMPARTILHAMENTO DE DADOS COM TERCEIROS
              </Typography>
              <Typography>
                4 – NOSSO COMPROMISSO COM A SEGURANÇA DE DADOS
              </Typography>
              <Typography>5 – DISPOSIÇÕES FINAIS</Typography>
              <Typography>
                6 – CONTROLE DE ACESSO E ATUALIZAÇÃO DE PRIVACIDADE
              </Typography>
              <Typography>
                7 – ATUALIZAÇÕES DA POLÍTICA DE PRIVACIDADE
              </Typography>
            </Typography> */}
            {/* <br /> */}
            <Typography textAlign="justify">
              A Fretapp está comprometida com sua privacidade em todas suas
              plataformas. Esta Política de Privacidade descreve os tipos de
              informação que coletamos sobre você quando você visita nosso
              aplicativo móvel ("Fretapp") ou usa nossos serviços
              online na web, Aplicativo e serviços online ("Serviço"). Esta
              informação que coletamos sobre você quando você visita nosso
              aplicativo móvel ("Fretapp") ou usa nossos serviços
              online na web, Aplicativo e serviços online ("Serviço"). Esta
              Política de Privacidade explica como a Fretapp pode usar e
              divulgar essas informações e também como fazemos para garantir a
              segurança dos seus dados, tudo em conformidade com o Código de
              Defesa do Consumidor (Lei nº 8.078/1990), Marco Civil da Internet
              (Lei nº 12.965/2014), Lei Geral de Proteção de Dados Pessoais (Lei
              nº 13.709/2018) e o Regulamento Geral sobre a Proteção de Dados
              2016/679 da União Europeia (GDPR).
            </Typography>
            <br />
            {steps.map((Step, index) => (
              <Step numberStep={index + 1} />
            ))}
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};
export default PrivacyPolicy;
